(function () { if (!LN.Core) throw new Error("LN.Core missing"); })();
(function (App, View, Handler, Service, Controller, Config, Helper, Message, Model, Analytics, Hotjar, $) {
    'use strict';

    // ==================================================
    // Manejador datos credenciales 
    // ================================================== 
    Handler.obtenerDatosClubHandler = function (obj, status, xhr) {
        console.log('ObtenerDatosHandler | ' + obj.code);
        //if(!code ==)
        switch (obj.code) {
            //Caso Todo OK
            case '1':
            case '2':
                Model.Usuario.Credenciales = (obj.response !== null) ? obj.response : [];
                //if (Model.Usuario.TipoAsociarCredencial == "") Model.Usuario.TipoAsociarCredencial = obj.code;
                Model.Usuario.TipoAsociarCredencial = obj.code;
                View.asociarTarjeta();
                break;
            case '0001':
                logger && logger.fatal('ObtenerDatosHandler | Error General', { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
                    'text': Message.Usuario['VOLVER_A_INTENTARLO'],
                    'stepBack': 'volver_a_ingresar'
                });
                break;
            default:
                logger && logger.error('ObtenerDatosHandler | No existe el tipo de estado (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de estado");
        }
    }

    Handler.asociarResponseHandler = function (obj, status, xhr) {
        console.log('AsociarHandler | ' + obj.code);
        switch (obj.code) {
            case '1':
                // Chequeo si vengo de combo 1-2 o combo 3 . 
                if (Model.Cliente.comboElegido == Config.COMBO_BONIFICADO) Service.actualizarCookies(function () {
                    var usuarioDetalleClubNacion = Helper.readCookie("usuarioDetalleClubNacion");
                    Analytics.asociacionExitosa(usuarioDetalleClubNacion, Model.Window.lastFlow);
                    Controller.flowE();
                })
                else Service.actualizarCookies(function () {
                    var usuarioDetalleClubNacion = Helper.readCookie("usuarioDetalleClubNacion");
                    Analytics.asociacionExitosa(usuarioDetalleClubNacion, Model.Window.lastFlow);
                    View.primerAcceso();
                });
                break;
            case '-1':
                // Esto es para form corto 
                // Chequeo si el response del -1 error corresponde a credencial ya asociada a otro usuario . 
                if (obj.message == 'Ya existe la relacion') {
                    var errMsg = Message.Credencial['ERROR_YA_ASOCIADO'];
                    errMsg = errMsg.replace("{{email}}", obj.response);
                    View.asociarTarjeta(errMsg, 'advertencia', function () {
                        Helper.HideVincularTarjetaForm();
                        Helper.HideSubTituloTarjetaForm();
                        Hotjar.callTrigger('LN.Paywall.Vinculacion.ErrorEmail');
                    });
                } else {
                    logger && logger.error('AsociarHandler | Error General', { Response: obj, Model: Model });
                    var errMsg = Message.Credencial['ERROR_ASOCIAR'];
                    View.asociarTarjeta(errMsg, 'error');
                }
                break;
            case '-2':
                View.asociarTarjeta(Message.Credencial['ERROR_NO_COINCIDEN'], 'error');
                break;
            case '-3':
                var mensaje = Message.Credencial['ERROR_YA_ASOCIADO'];
                mensaje = mensaje.replace("{{email}}", obj.response);
                View.asociarTarjeta(mensaje, 'advertencia', function () {
                    Helper.HideVincularTarjetaForm();
                    Helper.HideSubTituloTarjetaForm();
                    Hotjar.callTrigger('LN.Paywall.Vinculacion.ErrorEmail');
                });

                break;
            default:
                logger && logger.error('AsociarHandler | No existe el tipo de estado (' + obj.code + ')', { Response: obj, Model: Model });
                View.asociarTarjeta(Message.Credencial['ERROR_ASOCIAR'], 'error');

        }
    }

})(LN.App, LN.View, LN.Handler, LN.Service, LN.Controller, LN.Config, LN.Helper, LN.Message, LN.Model, LN.Analytics, LN.Hotjar, jQuery);


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/handlers/credencialHandler.js